import { IconPropsBase } from './IconPropsBase';

export default function ComputerIcon({ size = 20, color = 'currentColor' }: IconPropsBase) {
  if (size > 20) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 -960 960 960">
        <path
          fill={color}
          d="M55.39-150.77v-60h849.22v60H55.39Zm116.92-100q-30.31 0-51.31-21-21-21-21-51.31v-415.38q0-30.31 21-51.31 21-21 51.31-21h615.38q30.31 0 51.31 21 21 21 21 51.31v415.38q0 30.31-21 51.31-21 21-51.31 21H172.31Zm0-60h615.38q4.62 0 8.46-3.84 3.85-3.85 3.85-8.47v-415.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v415.38q0 4.62 3.85 8.47 3.84 3.84 8.46 3.84Zm-12.31 0v-440 440Z"
        />
      </svg>
    );
  } else {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 -960 960 960">
        <path
          fill={color}
          d="M63.39-174.77v-52h833.22v52H63.39Zm116.92-100q-27.01 0-45.66-18.65Q116-312.07 116-339.08v-383.38q0-27.01 18.65-45.66 18.65-18.65 45.66-18.65h599.38q27.01 0 45.66 18.65Q844-749.47 844-722.46v383.38q0 27.01-18.65 45.66-18.65 18.65-45.66 18.65H180.31Zm0-52h599.38q4.62 0 8.46-3.84 3.85-3.85 3.85-8.47v-383.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H180.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v383.38q0 4.62 3.85 8.47 3.84 3.84 8.46 3.84Zm-12.31 0v-408 408Z"
        />
      </svg>
    );
  }
}
